import { render, staticRenderFns } from "./ViewService.vue?vue&type=template&id=28c7ddb0&scoped=true&"
import script from "./ViewService.vue?vue&type=script&lang=js&"
export * from "./ViewService.vue?vue&type=script&lang=js&"
import style0 from "./ViewService.vue?vue&type=style&index=0&id=28c7ddb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7ddb0",
  null
  
)

export default component.exports